// Booking-page translations. Keep strings short, sober, elegant.

export const BOOKING = {
  de: {
    title: "Reservation",
    subtitle: "Ihre private Fahrt — von Adresse zu Adresse, in unter zwei Minuten bestätigt.",
    services: {
      transfer: "Transfer",
      transferDesc: "Punkt-zu-Punkt · Flughafen, Hotel, privat.",
      byHour: "Stundenweise",
      byHourDesc: "Chauffeur zur Verfügung. Ab 2 Stunden.",
      multicity: "Mehrere Halte",
      multicityDesc: "Mehrere Stopps in einer Fahrt — Roadshow, Termine, Genussfahrt.",
      fullDay: "Ganztägig",
      fullDayDesc: "8 Stunden ab CHF 980. Region Ihrer Wahl.",
      courier: "Kurier",
      courierDesc: "Vertrauliche Dokumente von Hand zu Hand.",
    },
    pickup: "Abholung",
    current: "Aktuelle",
    addressPh: "Adresse, Hotel, Flughafen…",
    hours: "Stunden",
    minHoursNote: "min. 2 h · CHF 110/h",
    fullDayNote: "min. 8 h · CHF 110/h zusätzlich",
    stopN: (n) => `Halt ${n}`,
    addStop: "Halt hinzufügen",
    swap: "Tauschen",
    multicityLegalNote: "Alle Halte an sicheren, verkehrslegalen Punkten gemäss Schweizer Strassenverkehrsrecht.",
    when: "Datum & Uhrzeit",
    passengers: "Personen",
    childSeats: "Kindersitze",
    pet: "Tier",
    petOptions: { none: "Kein Tier", noCarrier: "Tier · ohne Box", withCarrier: "Tier · mit Box" },
    flight: "Flugnummer",
    optional: "optional",
    luggage: "Gepäck",
    luggagePh: "Anzahl und Grösse der Taschen",
    name: "Vollständiger Name",
    email: "E-Mail",
    phone: "Telefon (+41 oder international)",
    notes: "Anmerkungen",
    notesPh: "Besondere Wünsche, Sitzpräferenz, Wasser an Bord…",
    terms: "Ich akzeptiere die Allgemeinen Geschäftsbedingungen und die Stornierungsbedingungen (≥ 48 h: volle Rückerstattung · 24–48 h: 50 % Rückerstattung + 50 % Guthaben · < 24 h: volles Guthaben, 6 Monate gültig).",
    pay: "Bezahlen",
    redirecting: "Weiterleitung…",
    escrowNote: "Ihre Zahlung wird von unserem Anbieter treuhänderisch verwahrt und erst nach abgeschlossener Fahrt an SwissAlpenLine ausgezahlt.",
    calculating: "Berechnung…",
    total: "Gesamt",
    distance: "Distanz",
    duration: "Dauer",
    hourTier: "Zeitzone",
    fullDayExtra: "Zusatzstunde: CHF 110 · Region Ihrer Wahl.",
    multicityStops: (n) => `${n} zusätzliche ${n === 1 ? "Halt" : "Halte"}`,
    idVerify: "Reservationen über CHF 500 erfordern eine Identitätsprüfung — der Kartenname muss mit dem Fahrgast übereinstimmen.",
    enterRoute: "Route eingeben, um den Preis zu sehen.",
    singleCar: {
      title: "Ein Fahrzeug · eine Chauffeurin",
      body: "SwissAlpenLine fährt derzeit exklusiv mit einem BYD Seal U DM-i (2025). Jeder Zeitslot ist einzigartig — mit einem Sicherheitspuffer für den Wechsel zwischen Fahrten.",
    },
    nextSlot: { label: "Nächster freier Termin", cta: "Übernehmen" },
    conflict: {
      title: "Zeitfenster nicht verfügbar",
      body: "Dieser Zeitpunkt ist bereits reserviert (ein Fahrzeug, eine Chauffeurin). Bitte wählen Sie eine andere Uhrzeit oder ein anderes Datum.",
    },
    errors: {
      required: "Bitte alle Pflichtfelder ausfüllen.",
      terms: "Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen.",
      stopsRequired: "Mehrhalte-Fahrt benötigt mindestens einen Zwischenhalt.",
      minHours: "Stundenweise: mindestens 2 Stunden.",
      conflict: "Dieses Zeitfenster ist nicht verfügbar. Bitte wählen Sie eine andere Uhrzeit.",
      priceFailed: "Preis konnte nicht berechnet werden. Bitte erneut versuchen.",
      generic: "Fehler beim Erstellen der Reservation.",
    },
  },

  en: {
    title: "Reservation",
    subtitle: "Your private ride — address to address, confirmed in under two minutes.",
    services: {
      transfer: "Transfer",
      transferDesc: "Point-to-point · Airport, hotel, private.",
      byHour: "By the hour",
      byHourDesc: "Chauffeur at your disposal. From 2 hours.",
      multicity: "Multiple stops",
      multicityDesc: "Several stops in one ride — roadshow, meetings, leisure.",
      fullDay: "Full day",
      fullDayDesc: "8 hours from CHF 980. Region of your choice.",
      courier: "Courier",
      courierDesc: "Confidential hand-to-hand document delivery.",
    },
    pickup: "Pickup",
    current: "Current",
    addressPh: "Address, hotel, airport…",
    hours: "Hours",
    minHoursNote: "min. 2 h · CHF 110/h",
    fullDayNote: "min. 8 h · CHF 110/h extra",
    stopN: (n) => `Stop ${n}`,
    addStop: "Add stop",
    swap: "Swap",
    multicityLegalNote: "All stops at safe, road-law compliant points per Swiss traffic regulations.",
    when: "Date & time",
    passengers: "Passengers",
    childSeats: "Child seats",
    pet: "Pet",
    petOptions: { none: "No pet", noCarrier: "Pet · no carrier", withCarrier: "Pet · with carrier" },
    flight: "Flight number",
    optional: "optional",
    luggage: "Luggage",
    luggagePh: "Number and size of bags",
    name: "Full name",
    email: "Email",
    phone: "Phone (+41 or international)",
    notes: "Notes",
    notesPh: "Special requests, seat preference, water on board…",
    terms: "I accept the Terms & Conditions and the cancellation policy (≥ 48 h: full refund · 24–48 h: 50 % refund + 50 % credit · < 24 h: full credit valid 6 months).",
    pay: "Pay",
    redirecting: "Redirecting…",
    escrowNote: "Your payment is held in escrow by our provider and released to SwissAlpenLine only after the trip is completed.",
    calculating: "Calculating…",
    total: "Total",
    distance: "Distance",
    duration: "Duration",
    hourTier: "Time tier",
    fullDayExtra: "Extra hour: CHF 110 · region of your choice.",
    multicityStops: (n) => `${n} additional ${n === 1 ? "stop" : "stops"}`,
    idVerify: "Reservations above CHF 500 require identity verification — the card name must match the passenger.",
    enterRoute: "Enter your route to see the price.",
    singleCar: {
      title: "One vehicle · one chauffeur",
      body: "SwissAlpenLine currently operates a single BYD Seal U DM-i (2025). Every time slot is unique — with a safety buffer between rides.",
    },
    nextSlot: { label: "Next available slot", cta: "Use this time" },
    conflict: {
      title: "Time slot unavailable",
      body: "This time is already reserved (one vehicle, one chauffeur). Please choose another time or date.",
    },
    errors: {
      required: "Please fill in all required fields.",
      terms: "Please accept the Terms & Conditions.",
      stopsRequired: "Multi-stop rides require at least one intermediate stop.",
      minHours: "By-the-hour: minimum 2 hours.",
      conflict: "This time slot is unavailable. Please choose another time.",
      priceFailed: "Unable to compute price. Please try again.",
      generic: "Error creating reservation.",
    },
  },

  pt: {
    title: "Reserva",
    subtitle: "A sua viagem privada — porta-a-porta, confirmada em menos de dois minutos.",
    services: {
      transfer: "Transfer",
      transferDesc: "Ponto-a-ponto · aeroporto, hotel, privado.",
      byHour: "À hora",
      byHourDesc: "Chauffeur à sua disposição. Mínimo 2 horas.",
      multicity: "Várias paragens",
      multicityDesc: "Várias paragens numa só viagem — roadshow, reuniões, lazer.",
      fullDay: "Dia completo",
      fullDayDesc: "8 horas desde CHF 980. Região à sua escolha.",
      courier: "Courier",
      courierDesc: "Entrega confidencial de documentos mão-a-mão.",
    },
    pickup: "Recolha",
    current: "Atual",
    addressPh: "Morada, hotel, aeroporto…",
    hours: "Horas",
    minHoursNote: "mín. 2 h · CHF 110/h",
    fullDayNote: "mín. 8 h · CHF 110/h extra",
    stopN: (n) => `Paragem ${n}`,
    addStop: "Adicionar paragem",
    swap: "Trocar",
    multicityLegalNote: "Todas as paragens em locais seguros e legais segundo o código da estrada suíço.",
    when: "Data e hora",
    passengers: "Passageiros",
    childSeats: "Cadeiras de criança",
    pet: "Animal",
    petOptions: { none: "Sem animal", noCarrier: "Animal · sem transportadora", withCarrier: "Animal · com transportadora" },
    flight: "Nº de voo",
    optional: "opcional",
    luggage: "Bagagem",
    luggagePh: "Número e tamanho das malas",
    name: "Nome completo",
    email: "Email",
    phone: "Telefone (+41 ou internacional)",
    notes: "Notas",
    notesPh: "Pedidos especiais, preferência de lugar, água a bordo…",
    terms: "Aceito os Termos e Condições e a política de cancelamento (≥ 48 h: reembolso total · 24–48 h: 50 % reembolso + 50 % crédito · < 24 h: crédito total válido 6 meses).",
    pay: "Pagar",
    redirecting: "A redirecionar…",
    escrowNote: "O seu pagamento fica retido pelo nosso fornecedor de pagamentos e é libertado à SwissAlpenLine apenas depois da viagem concluída.",
    calculating: "A calcular…",
    total: "Total",
    distance: "Distância",
    duration: "Duração",
    hourTier: "Faixa horária",
    fullDayExtra: "Hora extra: CHF 110 · região à sua escolha.",
    multicityStops: (n) => `${n} paragem${n === 1 ? "" : "s"} adicional${n === 1 ? "" : "is"}`,
    idVerify: "Reservas acima de CHF 500 requerem verificação de identidade — o nome do cartão deve coincidir com o passageiro.",
    enterRoute: "Introduza a sua rota para ver o preço.",
    singleCar: {
      title: "Um veículo · uma chauffeur",
      body: "A SwissAlpenLine opera atualmente com um único BYD Seal U DM-i (2025). Cada horário é único — com margem de segurança entre viagens.",
    },
    nextSlot: { label: "Próximo horário livre", cta: "Usar esta hora" },
    conflict: {
      title: "Horário indisponível",
      body: "Este horário já está reservado (um veículo, uma chauffeur). Por favor, escolha outra hora ou data.",
    },
    errors: {
      required: "Preencha todos os campos obrigatórios.",
      terms: "Aceite os Termos e Condições.",
      stopsRequired: "Viagens multi-paragem requerem pelo menos uma paragem intermédia.",
      minHours: "Serviço à hora: mínimo 2 horas.",
      conflict: "Este horário está indisponível. Escolha outra hora.",
      priceFailed: "Não foi possível calcular o preço. Tente novamente.",
      generic: "Erro ao criar reserva.",
    },
  },

  fr: {
    title: "Réservation",
    subtitle: "Votre trajet privé — d'adresse à adresse, confirmé en moins de deux minutes.",
    services: {
      transfer: "Transfert",
      transferDesc: "Point-à-point · aéroport, hôtel, privé.",
      byHour: "À l'heure",
      byHourDesc: "Chauffeur à disposition. Dès 2 heures.",
      multicity: "Multi-arrêts",
      multicityDesc: "Plusieurs arrêts dans un même trajet — roadshow, rendez-vous, loisirs.",
      fullDay: "Journée complète",
      fullDayDesc: "8 heures dès CHF 980. Région de votre choix.",
      courier: "Courrier",
      courierDesc: "Livraison confidentielle de documents en main propre.",
    },
    pickup: "Prise en charge",
    current: "Actuelle",
    addressPh: "Adresse, hôtel, aéroport…",
    hours: "Heures",
    minHoursNote: "min. 2 h · CHF 110/h",
    fullDayNote: "min. 8 h · CHF 110/h supplémentaire",
    stopN: (n) => `Arrêt ${n}`,
    addStop: "Ajouter un arrêt",
    swap: "Inverser",
    multicityLegalNote: "Tous les arrêts en des points sûrs et conformes au code de la route suisse.",
    when: "Date et heure",
    passengers: "Passagers",
    childSeats: "Sièges enfant",
    pet: "Animal",
    petOptions: { none: "Sans animal", noCarrier: "Animal · sans caisse", withCarrier: "Animal · avec caisse" },
    flight: "Numéro de vol",
    optional: "optionnel",
    luggage: "Bagages",
    luggagePh: "Nombre et taille des bagages",
    name: "Nom complet",
    email: "Email",
    phone: "Téléphone (+41 ou international)",
    notes: "Notes",
    notesPh: "Demandes particulières, siège, eau à bord…",
    terms: "J'accepte les Conditions Générales et la politique d'annulation (≥ 48 h : remboursement total · 24–48 h : 50 % remboursé + 50 % avoir · < 24 h : avoir total valable 6 mois).",
    pay: "Payer",
    redirecting: "Redirection…",
    escrowNote: "Votre paiement est conservé par notre prestataire et versé à SwissAlpenLine uniquement après la fin du trajet.",
    calculating: "Calcul…",
    total: "Total",
    distance: "Distance",
    duration: "Durée",
    hourTier: "Plage horaire",
    fullDayExtra: "Heure supplémentaire : CHF 110 · région de votre choix.",
    multicityStops: (n) => `${n} arrêt${n === 1 ? "" : "s"} supplémentaire${n === 1 ? "" : "s"}`,
    idVerify: "Réservations supérieures à CHF 500 : vérification d'identité requise — le nom sur la carte doit correspondre au passager.",
    enterRoute: "Saisissez votre trajet pour voir le prix.",
    singleCar: {
      title: "Un véhicule · une chauffeure",
      body: "SwissAlpenLine opère actuellement avec une seule BYD Seal U DM-i (2025). Chaque créneau est unique — avec une marge de sécurité entre les trajets.",
    },
    nextSlot: { label: "Prochain créneau libre", cta: "Utiliser ce créneau" },
    conflict: {
      title: "Créneau indisponible",
      body: "Ce créneau est déjà réservé (un véhicule, une chauffeure). Merci de choisir un autre horaire ou une autre date.",
    },
    errors: {
      required: "Merci de remplir tous les champs requis.",
      terms: "Merci d'accepter les Conditions Générales.",
      stopsRequired: "Multi-arrêts : au moins un arrêt intermédiaire requis.",
      minHours: "À l'heure : minimum 2 heures.",
      conflict: "Ce créneau est indisponible. Choisissez un autre horaire.",
      priceFailed: "Impossible de calculer le prix. Réessayez.",
      generic: "Erreur lors de la création de la réservation.",
    },
  },

  it: {
    title: "Prenotazione",
    subtitle: "Il tuo viaggio privato — indirizzo a indirizzo, confermato in meno di due minuti.",
    services: {
      transfer: "Transfer",
      transferDesc: "Punto-punto · aeroporto, hotel, privato.",
      byHour: "Ad ore",
      byHourDesc: "Chauffeur a disposizione. Da 2 ore.",
      multicity: "Multi-fermata",
      multicityDesc: "Più fermate in un unico viaggio — roadshow, appuntamenti, tempo libero.",
      fullDay: "Giornata intera",
      fullDayDesc: "8 ore da CHF 980. Regione a tua scelta.",
      courier: "Corriere",
      courierDesc: "Consegna riservata di documenti a mano.",
    },
    pickup: "Ritiro",
    current: "Attuale",
    addressPh: "Indirizzo, hotel, aeroporto…",
    hours: "Ore",
    minHoursNote: "min. 2 h · CHF 110/h",
    fullDayNote: "min. 8 h · CHF 110/h extra",
    stopN: (n) => `Fermata ${n}`,
    addStop: "Aggiungi fermata",
    swap: "Inverti",
    multicityLegalNote: "Tutte le fermate in punti sicuri e conformi al codice della strada svizzero.",
    when: "Data e ora",
    passengers: "Passeggeri",
    childSeats: "Seggiolini bambino",
    pet: "Animale",
    petOptions: { none: "Nessun animale", noCarrier: "Animale · senza trasportino", withCarrier: "Animale · con trasportino" },
    flight: "Numero volo",
    optional: "opzionale",
    luggage: "Bagagli",
    luggagePh: "Numero e dimensione dei bagagli",
    name: "Nome completo",
    email: "Email",
    phone: "Telefono (+41 o internazionale)",
    notes: "Note",
    notesPh: "Richieste speciali, posto, acqua a bordo…",
    terms: "Accetto i Termini e Condizioni e la politica di cancellazione (≥ 48 h: rimborso totale · 24–48 h: 50 % rimborso + 50 % credito · < 24 h: credito totale valido 6 mesi).",
    pay: "Paga",
    redirecting: "Reindirizzamento…",
    escrowNote: "Il pagamento è custodito dal nostro fornitore ed erogato a SwissAlpenLine solo dopo la fine del viaggio.",
    calculating: "Calcolo…",
    total: "Totale",
    distance: "Distanza",
    duration: "Durata",
    hourTier: "Fascia oraria",
    fullDayExtra: "Ora extra: CHF 110 · regione a tua scelta.",
    multicityStops: (n) => `${n} fermat${n === 1 ? "a" : "e"} aggiuntiv${n === 1 ? "a" : "e"}`,
    idVerify: "Prenotazioni sopra CHF 500: verifica d'identità — il nome della carta deve coincidere con il passeggero.",
    enterRoute: "Inserisci il percorso per vedere il prezzo.",
    singleCar: {
      title: "Un veicolo · una chauffeur",
      body: "SwissAlpenLine opera attualmente con un unico BYD Seal U DM-i (2025). Ogni orario è unico — con un margine di sicurezza tra i viaggi.",
    },
    nextSlot: { label: "Prossimo orario libero", cta: "Usa questo orario" },
    conflict: {
      title: "Orario non disponibile",
      body: "Questo orario è già prenotato (un veicolo, una chauffeur). Scegli un altro orario o data.",
    },
    errors: {
      required: "Compila tutti i campi obbligatori.",
      terms: "Accetta i Termini e Condizioni.",
      stopsRequired: "Multi-fermata: almeno una fermata intermedia.",
      minHours: "Ad ore: minimo 2 ore.",
      conflict: "Questo orario non è disponibile. Scegli un altro orario.",
      priceFailed: "Impossibile calcolare il prezzo. Riprova.",
      generic: "Errore nella creazione della prenotazione.",
    },
  },
};

export const getBooking = (lang) => BOOKING[lang] || BOOKING.de;
